<!-- Start: Rejwan: 08-04-2026 Early loan settlement -->
<template>
    <b-overlay :show="showoverlaymodal" rounded="sm" class="pf_loan_form_front row">
        <div class="col-sm-12 col-md-12">
            <b-form @submit.stop.prevent="onSubmit">
                <div class="row col-12 no-margin px-0">

                    <!-- Employee Info -->
                    <div class="ibox col-md-12 pf-loan-form no-shadow border">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Employee Info</span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <div class="ibox-content px-0">
                            <div class="row text-center">
                                <div class="col-lg-6">
                                    <h3>Employee Name: {{ employee_details.name }}</h3>
                                    <h3>Employee Code: {{ employee_details.code }}</h3>
                                </div>
                                <div class="col-lg-6">
                                    <h3>Date of Joining: {{ employee_details.date_of_joining }}</h3>
                                    <h3>PF Start Date: {{ employee_details.pf_start_date }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Advance Details -->
                    <div class="ibox col-md-12 border-0">
                        <div class="ibox-title dashboard_title">
                            <h4 class="clearfix">
                                <span class="float-left">Advance Details</span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                        <div class="ibox-content px-1 pb-0">
                            <div class="clearfix loan_card_wrapper rounded px-0 col-md-12 pb-0">
                                <div class="row">
                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group label="Advance Amount" label-for="loan_amount">
                                            <b-form-input id="loan_amount" name="loan_amount" disabled v-model="fdata.loan_amount"></b-form-input>
                                        </b-form-group>

                                        <b-form-group label="Amount Paid" label-for="paid_amount">
                                            <b-form-input id="paid_amount" name="paid_amount" disabled v-model="fdata.paid_amount"></b-form-input>
                                        </b-form-group>
                                        
                                    </div>

                                    <div class="col-sm-6 mt-1 mb-1">
                                        <b-form-group label="Interest Amount" label-for="interest_amount">
                                            <b-form-input id="interest_amount" name="interest_amount" disabled v-model="fdata.interest_amount"></b-form-input>
                                        </b-form-group>

                                        <!-- Start: Rejwan: 23-06-2026 -->
                                        <b-form-group label="Date" label-for="date_text" :state="validateState('date_text')" :invalid-feedback="veeErrors.first('date_text')" class="required-field"> <!-- Mustafijur: 23-08-2026 -->
                                            <b-input-group class="mb-3"> <!-- Mustafijur: 23-08-2026 -->
                                                <b-input-group-append class="w-100"> <!-- Mustafijur: 23-08-2026 -->
                                                    <b-form-input id="date_text" name="date_text" v-model="fdata.date" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('date_text')" aria-describedby="date_text-feedback" data-vv-as="Date" style="border-top-right-radius: 0px;border-bottom-right-radius: 0px;"></b-form-input> <!-- Mustafijur: 23-08-2026 -->
                                                    <b-form-datepicker id="date_picker" button-only right locale="en-US" v-model="fdata.date"></b-form-datepicker>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                        <!-- End: Rejwan: 23-06-2026 -->

                                        <b-form-group label="Amount Remaining" label-for="remaining_amount">
                                            <b-form-input id="remaining_amount" name="remaining_amount" v-validate="{ required: true }" :state="validateState('remaining_amount')" v-model="fdata.remaining_amount" data-vv-as="Amount Remaining" aria-describedby="remaining_amount-feedback"></b-form-input>
                                            <b-form-invalid-feedback id="remaining_amount-feedback">{{ veeErrors.first('remaining_amount') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </div>

                                <!-- Attachments & Submit -->
                                <div class="row">
                                    <div class="col-sm-12 mt-1 mb-3 d-flex gap-2">
                                        <a href="javascript:void(0);" class="btn mb-2 btn-secondary d-inline-block px-4 mr-3" @click="showAttachments()">
                                            View Attachments
                                        </a>
                                        <button type="submit" class="btn mb-2 btn-primary d-inline-block px-4">
                                            Submit
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </b-form>
        </div>

        <b-modal id="show_attachments" size="lg" hide-footer title="Advance Files" scrollable>
            <pf-loan-documents-front :pageurl="this.$api_url" flg="1" :is_self="is_self" :key="flg_key" :loan_id="loan_id" type="loan_early_settlement"></pf-loan-documents-front>
        </b-modal>
    </b-overlay>
</template>

<script>
export default {
    props: ['flg', 'employee_id', 'employee_name', 'count', 'loan_id', 'is_self'],

    data() {
        return {
            showoverlaymodal: true,
            flg_key: 0,
            employee_details: {},
            fdata: {
                id: '',
                employee_id: '',
                loan_amount: '',
                paid_amount: '',
                remaining_amount: '',
                interest_amount: '',
                date: null,
            },
        };
    },

    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        showAttachments() {
            this.$bvModal.show('show_attachments');
            this.flg_key += 1;
        },

        getEarlySettlmentInfo(loan_id) {
            let url = this.$api_url_front + '/self/pf/loan/early-settlement/info'

            axios.get(url, { params: { loan_id: loan_id } })
                .then((response) => {
                    const data = response.data;
                    this.fdata.id             = data.id;
                    this.fdata.employee_id    = data.employee_id;
                    this.fdata.loan_amount    = this.formatMoney(data.loan_amount);
                    this.fdata.paid_amount    = this.formatMoney(data.paid_amount);
                    this.fdata.interest_amount = this.formatMoney(data.interest_amount);
                    this.fdata.remaining_amount = this.formatMoney(data.remaining_amount);
                    this.fdata.date           = data.date;
                    this.employee_details     = data.employee ?? {};
                    this.showoverlaymodal     = false;
                    
                    this.$nextTick(() => {
                        this.$validator.reset(); // ✅ Clears dirty/validated state after data load
                    });
                })
                .catch((error) => {
                    this.showoverlaymodal = false;
                    this.$bvToast.toast('Failed to load advance details.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                    });
                });
        },

        onSubmit() {
            if (!this.checkNet()) return false;

            this.$validator.validateAll().then((result) => {
                if (!result) return;
                let url = this.$api_url_front + '/self/pf/loan/early-settlement';

                let formData = new FormData();
                formData.append('loan_id', this.loan_id);
                formData.append('date', this.fdata.date);
                formData.append('remaining_amount', this.fdata.remaining_amount);

                axios.post(url, formData)
                    .then((response) => {
                        this.$bvToast.toast('Early settlement submitted successfully.', {
                            title: 'Success',
                            variant: 'success',
                            solid: true,
                        });
                        setTimeout(() => {
                            this.$emit('childToParent');
                        }, 500);
                    })
                    .catch((error) => {
                        const data = error.response?.data;
                        const msg = data?.errors
                            ? Object.values(data.errors).flat()[0]
                            : (data?.error ?? 'Submission failed.');
                        this.$bvToast.toast(msg, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                        });
                    });
            });
        },
    },

    created() {
        if (this.loan_id > 0) {
            this.getEarlySettlmentInfo(this.loan_id);
        } else {
            this.showoverlaymodal = false;
        }
    },
};
</script>

<style scoped>
.loan-card-title {
   /* text-align: center; */
   padding-bottom: 10px;
   font-size: 16px;
   /* color: #00c5fb !important; */
}

.loan_card_wrapper {
   padding-top: 12px;
   padding-bottom: 12px;
}
.pf_loan_form_front .b-overlay
{
	height: 100%;
}
.loan_form_bank_details .col-form-label {
	color: #3A52A6;
}
 
.ess-portal .ibox-content .custom-file-label span {
	font-size: 12px;
	color: #3A52A6;
	font-weight: unset;
}

#deduction_start_month_1-group input {
	background-color: #e9ecef;
	pointer-events: none;
}
#confirm_terms-group .custom-control-label::after {
	/* display: ; */
	top: 0.12rem;
} 
#confirm_terms-group .custom-control-label::before {
	top: 0.12rem;
}
#confirm_terms-group .custom-control-input.is-valid:checked ~ .custom-control-label::before {
	border-color: #3A52A6 !important;
	background-color: #3A52A6 !important;
}
/* Start: Rejwan: 07-01-2026 Attachment text show */
.bkash-ess-portal .ibox-content .custom-file-label span {
    font-size: 12px;
    color: #3A52A6 !important;
    font-weight: unset;
}
</style>
<!-- End: Rejwan: 08-04-2026 Early loan settlement -->
